import { z } from 'zod';

// HH:MM 24-hour. Hours 00-23, minutes 00-59. Canonical schedule-time pattern —
// the single source shared by the zod schema below and the configure-step AI
// list validator (update_step_configuration.js), so odd-minute times like
// "12:03" are accepted uniformly at rest and at the sub-agent tool boundary.
export const HH_MM_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;

const daysSchema = z.array(z.number().int().min(0).max(6)).optional().nullable();
const environmentsSchema = z.array(z.string().min(1)).optional().nullable();

const fixedSchema = z.object({
  scheduleType: z.literal('fixed'),
  runTimes: z.array(z.string().regex(HH_MM_REGEX, 'runTimes entries must match HH:MM (24h)')).min(1, 'runTimes must contain at least one HH:MM entry'),
  timeZone: z.string().min(1, 'timeZone is required for fixed schedules (e.g. "America/New_York")'),
  days: daysSchema,
  interval: z.number().int().positive().optional().nullable(),
  environments: environmentsSchema,
  time: z.string().nullable().optional()
});

const intervalSchema = z.object({
  scheduleType: z.literal('interval'),
  interval: z.number().int().positive('interval must be a positive integer number of milliseconds'),
  days: daysSchema,
  runTimes: z.array(z.string()).nullable().optional(),
  timeZone: z.string().nullable().optional(),
  environments: environmentsSchema,
  time: z.string().nullable().optional()
});

const scheduleArgumentsSchema = z.discriminatedUnion('scheduleType', [fixedSchema, intervalSchema]);

export const validateScheduleArguments = (value) => {
  const result = scheduleArgumentsSchema.safeParse(value);
  if (result.success) {
    return { ok: true, issues: [] };
  }
  const issues = result.error.issues.map((issue) => ({
    path: issue.path.join('.'),
    code: issue.code,
    message: issue.message
  }));
  return { ok: false, issues };
};

export const describeScheduleIssues = (issues) => {
  if (!Array.isArray(issues) || issues.length === 0) {
    return '';
  }
  return issues.map((issue) => (issue.path ? `${issue.path}: ${issue.message}` : issue.message)).join('; ');
};

export default scheduleArgumentsSchema;
